import {
    CAN_USE_INTEGRATION_SUCCESS,
    GET_BANKS_SUCCESS,
    GET_COMPANY_SUCCESS,
    GET_CONNECT_CALENDARS_SUCCESS,
    GET_CREDENTIAL_GLOBAL_SUCCESS,
    GET_DEPARTMENTS_SUCCESS,
    GET_JOBS_SUCCESS,
    GET_PLACES_SUCCESS,
    GET_COMPANIES_SUCCESS,
    GET_SERVICES_SUCCESS,
    GET_SYSTEM_INTEGRATIONS_SUCCESS,
    GET_ZOOM_USERS_SUCCESS,
    GET_TELEHEALTH_STATUS_SUCCESS,
    GET_SUPERVISION_CONFIG_SUCCESS,
    GET_ELIGIBILITY_AUTO_CHECK_CONFIG_SUCCESS,
    GET_MEMBERS_PORTAL_CONFIG_SUCCESS,
    REMOVE_SELECTED_CREDENTIAL,
    SELECTED_CREDENTIAL,
} from './system.type';

const initialState = {
    credentials: [],
    services: [],
    departments: [],
    jobs: [],
    places: [],
    companies: [],
    selectedCredential: null,
    company: null,
    calendars: null,
    bankList: [],

    systemIntegrations: [],
    canUseIntegrations: {},
    zoomUsers: [],

    zoomConnection: {},
    googleMeetConnection: {},
    supervisionConfig: null,
    eligibilityAutoCheckConfig: null,
    membersPortalConfig: null,
};

export const systemReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Service Type */
        case GET_SERVICES_SUCCESS:
            return {
                ...state,
                services: action.payload.services,
            };
        /** End */

        /** Credentials */
        case GET_CREDENTIAL_GLOBAL_SUCCESS:
            return {
                ...state,
                credentials: action.payload,
            };

        case SELECTED_CREDENTIAL:
            return {
                ...state,
                selectedCredential: action.payload,
            };

        case REMOVE_SELECTED_CREDENTIAL:
            return {
                ...state,
                selectedCredential: null,
            };

        /** End */

        /** Departments */
        case GET_DEPARTMENTS_SUCCESS:
            return {
                ...state,
                departments: action.payload,
            };
        /** End */

        /** Job */
        case GET_JOBS_SUCCESS:
            return {
                ...state,
                jobs: action.payload,
            };
        /** End */

        /** Place */
        case GET_PLACES_SUCCESS:
            return {
                ...state,
                places: action.payload,
            };
        /** End */

        /** Companies */
        case GET_COMPANIES_SUCCESS:
            return {
                ...state,
                companies: action.payload,
            };
        /** End */

        /** Company */
        case GET_COMPANY_SUCCESS:
            return {
                ...state,
                company: action.payload,
            };
        /** End */

        /** Calendars */
        case GET_CONNECT_CALENDARS_SUCCESS:
            return {
                ...state,
                calendars: action.payload,
            };
        /** End */

        /** Bank */
        case GET_BANKS_SUCCESS:
            return {
                ...state,
                bankList: action.payload,
            };
        /** End */

        /** Integrations */

        case GET_SYSTEM_INTEGRATIONS_SUCCESS:
            return {
                ...state,
                systemIntegrations: action.payload,
            };

        case CAN_USE_INTEGRATION_SUCCESS:
            return {
                ...state,
                canUseIntegrations: action.payload,
            };

        /** End */

        /** Zoom */

        case GET_ZOOM_USERS_SUCCESS:
            return {
                ...state,
                zoomUsers: action.payload,
            };

        /** End */

        /** Google Meet */

        case GET_TELEHEALTH_STATUS_SUCCESS:
            return {
                ...state,
                zoomConnection: { isConnected: action.payload.connected === 'ZOOM' },
                googleMeetConnection: { isConnected: action.payload.connected === 'GOOGLE_MEET' },
            };

        /** End */

        /** Supervision Config */
        case GET_SUPERVISION_CONFIG_SUCCESS:
            return {
                ...state,
                supervisionConfig: action.payload,
            };
        /** End */

        /** Eligibility Auto-Check Config */
        case GET_ELIGIBILITY_AUTO_CHECK_CONFIG_SUCCESS:
            return {
                ...state,
                eligibilityAutoCheckConfig: action.payload,
            };

        case GET_MEMBERS_PORTAL_CONFIG_SUCCESS:
            return {
                ...state,
                membersPortalConfig: action.payload,
            };
        /** End */

        default:
            return state;
    }
};
